import React from 'react'
import NavbarLayout from '../components/NavbarLayout'
import EmployeeList from '../components/Employees/EmployeeList'

const ExployeesLists = () => {
    return (
        <div className="screenshots-wrapper-page">
            <NavbarLayout>
                <EmployeeList />
            </NavbarLayout>
        </div>
    )
}

export default ExployeesLists